import { AccountRepository } from '../Repositories/AccountRepository';
import { mapResetPasswordError } from './AccountErrors';
import { ok, err, Result } from 'neverthrow';

export class ResetPasswordUseCase {
  constructor(private repo: AccountRepository) {}

  execute(accountId: number, newPassword: string): Promise<Result<void, string>> {
    if (!newPassword || newPassword.trim().length < 4) {
      return Promise.resolve(err('비밀번호는 최소 4자 이상이어야 합니다.'));
    }
    if (newPassword.trim().length > 20) {
      return Promise.resolve(err('비밀번호는 20자 이하여야 합니다.'));
    }
    
    return this.repo
      .resetPassword(accountId, newPassword)
      .then(() => ok<void, string>(undefined))
      .catch(e => err<void, string>(mapResetPasswordError(e).message));
  }
}